import script from "./LogosSection.vue?vue&type=script&setup=true&lang=js"
export * from "./LogosSection.vue?vue&type=script&setup=true&lang=js"

import "./LogosSection.vue?vue&type=style&index=0&id=30fbee3a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30fbee3a"]])

export default __exports__